import * as React from 'react';
import { cn } from '../../utils';
import './slider.scss';
import { useSelector } from '../../utils/useSelector';

type Props = Pick<
  React.HTMLAttributes<HTMLDivElement>,
  'children' | 'className'
> & {
  show: boolean;
  onClickOutside?: (e: any) => void;
};

export const Slider = ({
  show,
  children,
  onClickOutside,
  className
}: Props) => {
  const getMountPoint = useSelector(s => s.app?.elFn?.getMountPoint);
  const ref = React.useRef<HTMLDivElement>(null);
  const el = getMountPoint ? getMountPoint() : document;
  React.useEffect(() => {
    if (show) {
      const handleClickOutside = event => {
        if (onClickOutside && !ref?.current?.contains(event.target)) {
          onClickOutside(event);
        }
      };
      el.addEventListener('mousedown', handleClickOutside);
      return () => {
        el.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [el, show]);
  return (
    <div
      ref={ref}
      className={cn({ 'slider-in': show, [className]: !!className }, 'slider')}
    >
      {children}
    </div>
  );
};
